import { render, staticRenderFns } from "./AddOrUpdateQuestion.vue?vue&type=template&id=942bff28"
import script from "./AddOrUpdateQuestion.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateQuestion.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateQuestion.vue?vue&type=style&index=0&id=942bff28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports